<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        bottom
        color="success"
        overlap
        offset-x="12"
        offset-y="12"
        class="ms-4"
        dot
      >
        <v-avatar
          size="40px"
          v-bind="attrs"
          v-on="on"
        >
          <v-img :src="getAvatarUrl()"></v-img>
        </v-avatar>
      </v-badge>
    </template>
    <v-list>
      <div class="pb-3 pt-2">
        <v-badge
          bottom
          color="success"
          overlap
          offset-x="12"
          offset-y="12"
          class="ms-4"
          dot
        >
          <v-avatar size="40px">
            <v-img :src="getAvatarUrl()"></v-img>
          </v-avatar>
        </v-badge>
        <div
          class="d-inline-flex flex-column justify-center ms-3"
          style="vertical-align:middle"
        >
          <span class="text--primary font-weight-semibold mb-n1">
            {{ getFullName() }}
          </span>
          <small class="text--disabled text-capitalize">
            {{ admin ? $t('admin') : $t('school') }}
          </small>
        </div>
      </div>

      <v-divider></v-divider>

      <!-- Profile -->
      <!-- a family has no profile screen, and a link to a school one
           bounces them back where they came from -->
      <v-list-item v-if="profileUrl" link v-bind="{ href: profileUrl }">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiAccountOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('profile') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Settings -->
      <!-- <v-list-item link href="/settings">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiCogOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('settings') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->


      <v-divider class="my-2"></v-divider>

      <!-- Logout -->
      <v-list-item link @click="logout">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiLogoutVariant }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('logout') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

import auth from '@/services/AuthService'

import {
  mdiAccountOutline,
  mdiEmailOutline,
  mdiCheckboxMarkedOutline,
  mdiChatOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
} from '@mdi/js'

import {Keys} from '/src/config.js'

export default {
  components: {
    Keys
  },
  //props
  props: {
    adminName: {
      type: String,
      default: '',
    },
    adminAvatar: {
      type: String,
      default: '',
    },
    profileUrl: {
      type: String,
      default: '',
    },
    admin:{
        type: Boolean,
        default: () => {}
    }
  },
  setup() {
    return {
      icons: {
        mdiAccountOutline,
        mdiEmailOutline,
        mdiCheckboxMarkedOutline,
        mdiChatOutline,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
      },
    }
  },
  methods: {
    getAvatarUrl() {
      return Keys.VUE_APP_API_URL + this.adminAvatar
    },
    getFullName() {
      return this.adminName
    },
    logout()
    {
      auth.logout()
    }
  }
}
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>
